import { Add } from "@mui/icons-material";
import {
    Alert,
    Button,
    Card,
    CardContent,
    CardHeader,
    CircularProgress,
    Grid,
    TextField,
    useTheme,
} from "@mui/material";
import { useMutation } from "@tanstack/react-query";
import { useEffect, useState } from "react";
import { POST } from "../../Utilities/BaseService";
import SearchableInput from "../Dashboard/Components/SearchableInput";

const addAdvancePayment = (advance: any) => POST("/advance", advance);

const CreateAdvancePayment = () => {
    const theme = useTheme();
    const [feedback, setFeedback] = useState("");

    // Initialize advance state
    const [advance, setAdvance] = useState({
        meterNo: "",
        advance: "",
        paymentMethod: "", // Will store payment method id or object
    });

    const [payment, setPayment] = useState<any>("");

    const addMutation = useMutation(addAdvancePayment, {
        onSuccess(res: any) {
            setFeedback(res.data?.message || "Advance payment successful!");
            // Optionally reset form
        },
        onError(err: any) {
            setFeedback(err.response?.data?.message || "Error occurred!");
        },
    });

    useEffect(() => {
        // If a payment is selected from SearchableInput
        if (payment) {
            setAdvance((prev) => ({
                ...prev,
                paymentMethod: payment["payment method"] || "",
            }));
        }
    }, [payment]);

    // Handle form submission
    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        if (!advance.meterNo || !advance.advance || !advance.paymentMethod) {
            setFeedback("Please fill all fields");
            return;
        }
        addMutation.mutate({
            ...advance,
            advance: Number(advance.advance), // convert string to number
        });
    };

    return (
        <>
            <Card sx={{ bgcolor: theme.palette.common.white }}>
                <CardHeader title="Create Advance Balance" />
                <CardContent>
                    <Grid
                        container
                        component="form"
                        spacing={2}
                        onSubmit={handleSubmit}
                    >
                        <Grid item xs={12} md={4}>
                            <TextField
                                size="small"
                                label="Meter No."
                                fullWidth
                                required
                                value={advance.meterNo}
                                onChange={(e) =>
                                    setAdvance({
                                        ...advance,
                                        meterNo: e.target.value,
                                    })
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <TextField
                                size="small"
                                label="Advance"
                                fullWidth
                                required
                                type="number"
                                value={advance.advance}
                                onChange={(e) =>
                                    setAdvance({
                                        ...advance,
                                        advance: e.target.value,
                                    })
                                }
                            />
                        </Grid>

                        <Grid item xs={12} md={4}>
                            <SearchableInput
                                api="/reading/payment-method"
                                label="Payment Method"
                                multiple={false}
                                filter={payment}
                                setFilter={setPayment}
                            />
                        </Grid>

                        <Grid item xs={12} md={4} sx={{ pt: 2 }}>
                            <Button
                                type="submit"
                                variant="outlined"
                                color="secondary"
                                startIcon={<Add />}
                                endIcon={
                                    addMutation.isLoading ? (
                                        <CircularProgress size={16} />
                                    ) : null
                                }
                                disabled={addMutation.isLoading}
                            >
                                Create Advance Payment
                            </Button>
                        </Grid>
                    </Grid>
                </CardContent>
            </Card>

            {feedback && (
                <Alert
                    severity={addMutation.isError ? "error" : "success"}
                    sx={{ mt: 2 }}
                >
                    {feedback}
                </Alert>
            )}
        </>
    );
};

export default CreateAdvancePayment;
